import { useState } from 'react'
import AuthenticatedLayout from '../../components/AuthenticatedLayout'
import { useForm, Link } from '@inertiajs/react'
import FormField from '../../components/FormField'
import Button from '../../components/Button'
import { uploadFile } from '../../utils/directUpload'

export default function ProductsNew({ activity }) {
  const { data, setData, post, processing, errors } = useForm({
    name: '',
    description: '',
    price: '',
    images: [],
  })
  const [uploading, setUploading] = useState(false)
  const [fileNames, setFileNames] = useState([])
  const [uploadError, setUploadError] = useState(null)

  async function handleFileChange(e) {
    const files = Array.from(e.target.files)
    if (files.length === 0) return

    setFileNames(files.map(f => f.name))
    setUploading(true)
    setUploadError(null)

    try {
      const blobs = await Promise.all(files.map(uploadFile))
      setData('images', blobs.map(b => b.signed_id))
    } catch {
      setUploadError('Uppladdning misslyckades. Försök igen.')
      setData('images', [])
      setFileNames([])
    } finally {
      setUploading(false)
    }
  }

  function handleSubmit(e) {
    e.preventDefault()
    post(`/activities/${activity.id}/products`)
  }

  return (
    <AuthenticatedLayout>
      <div className="max-w-lg">
        <div className="mb-6">
          <Link href={`/activities/${activity.id}`} className="text-sm text-indigo-600 hover:underline">
            ← {activity.name}
          </Link>
          <h1 className="text-2xl font-bold text-gray-900 mt-2">Ny produkt</h1>
        </div>

        <div className="bg-white rounded-xl border border-gray-200 p-6">
          <form onSubmit={handleSubmit} className="space-y-5">
            <FormField label="Namn" error={errors.name}>
              <input
                type="text"
                value={data.name}
                onChange={e => setData('name', e.target.value)}
                className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
              />
            </FormField>

            <FormField label="Pris (SEK)" error={errors.price}>
              <input
                type="number"
                min="0"
                step="0.01"
                value={data.price}
                onChange={e => setData('price', e.target.value)}
                className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
              />
            </FormField>

            <FormField label="Beskrivning" error={errors.description}>
              <textarea
                value={data.description}
                onChange={e => setData('description', e.target.value)}
                rows={3}
                className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
              />
            </FormField>

            <FormField label="Bilder">
              <input
                type="file"
                multiple
                accept="image/*"
                onChange={handleFileChange}
                className="w-full text-sm text-gray-600 file:mr-3 file:py-1.5 file:px-3 file:rounded-md file:border-0 file:text-sm file:font-medium file:bg-indigo-50 file:text-indigo-700 hover:file:bg-indigo-100"
              />
              {uploading && (
                <p className="mt-1 text-sm text-gray-500">Laddar upp {fileNames.length} bild{fileNames.length !== 1 ? 'er' : ''}…</p>
              )}
              {!uploading && fileNames.length > 0 && !uploadError && (
                <p className="mt-1 text-sm text-green-600">{fileNames.length} bild{fileNames.length !== 1 ? 'er' : ''} klar{fileNames.length !== 1 ? 'a' : ''} att skicka</p>
              )}
              {uploadError && (
                <p className="mt-1 text-sm text-red-600">{uploadError}</p>
              )}
            </FormField>

            <div className="flex gap-3">
              <Button type="submit" disabled={processing || uploading}>
                {processing ? 'Skapar…' : 'Skapa produkt'}
              </Button>
              <Link href={`/activities/${activity.id}`}>
                <Button type="button" variant="secondary">Avbryt</Button>
              </Link>
            </div>
          </form>
        </div>
      </div>
    </AuthenticatedLayout>
  )
}
